import React, { useState, useEffect, useCallback, createContext, useContext } from "react";

interface RouterContext {
  path: string;
  navigate: (to: string) => void;
}

const Ctx = createContext<RouterContext>({ path: "/", navigate: () => {} });

export function useRouter() {
  return useContext(Ctx);
}

export function Router({ children }: { children: React.ReactNode }) {
  const [path, setPath] = useState(window.location.pathname);

  const navigate = useCallback((to: string) => {
    window.history.pushState(null, "", to);
    setPath(to);
  }, []);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return <Ctx.Provider value={{ path, navigate }}>{children}</Ctx.Provider>;
}
